module.exports = {

  title: 'demo-test',//网站标题

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true
}



// WEBPACK FOOTER //
// ./src/settings.js